var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.receiptPreviewModal",modifiers:{"receiptPreviewModal":true}}],attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.setReceiptImage.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-receipt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }